/**
 * Utilidades FORM (pasos/campos) del editor de workflows (NIF-530).
 *
 * Abrir cuando: contrato API↔editor de pasos/campos, o flag `match_ocr` UI vs `validators[]`.
 * Reexporta el contract existente; añade helpers de match OCR usados por el builder.
 *
 * Sin dependencias Angular — puro y testeable.
 */

export {
	ensureFormEntityUuid,
	readFormStepsFromConfig,
	readStepFieldsFromApi,
	localeOrStringToDisplayText,
	isInternalFormStepShape,
	isApiFormStepShape,
	patchFormStepToEditor,
	patchFormStepFromApi,
	serializeFormStepToApi,
	patchFormFieldFromApi,
	serializeFormFieldToApi,
} from './form-operation-contract.util';

/**
 * Indica si el campo debe validar contra OCR
 * (`validators[]` contiene `match_ocr` o el control UI `match_ocr === true`).
 *
 * @param field - Valores del campo (API o form)
 */
export function resolveMatchOcrFlag(field: Record<string, unknown>): boolean {
	const validators = (field['validators'] as string[]) ?? [];
	return validators.includes('match_ocr') || field['match_ocr'] === true;
}

/**
 * Asegura `match_ocr` dentro de `validators[]` si el flag UI/API lo pide.
 * No muta el objeto original.
 *
 * @param field - Campo del form (puede traer `match_ocr` UI)
 */
export function withMatchOcrInValidators(field: Record<string, unknown>): Record<string, unknown> {
	const withMatchOcr = { ...field };
	const validators = [...((field['validators'] as string[]) ?? [])];
	if (resolveMatchOcrFlag(field) && !validators.includes('match_ocr')) {
		withMatchOcr['validators'] = [...validators, 'match_ocr'];
	}
	return withMatchOcr;
}

/**
 * Prepara `validators[]` para el FormGroup: quita `match_ocr` del array
 * (el flag UI vive en el control `match_ocr`).
 *
 * @param validators - Lista cruda
 */
export function stripMatchOcrFromValidators(validators: string[] | null | undefined): string[] {
	return (validators ?? []).filter((validator) => validator !== 'match_ocr');
}
